import { Injector } from '@angular/core';
import { RISK_PROFILES_LIST_APP_STATE_SLICE_KEY, RISK_PROFILES_LIST_STATE_KEYS } from '../state/constants';
import { AppStateService } from 'Angular/services/app-state.service';
import * as i0 from "@angular/core";
export class RiskProfilesListAppStateService {
    constructor(injector) {
        this.injector = injector;
    }
    get appStateService() {
        if (this._appStateService === undefined) {
            this._appStateService = this.injector.get(AppStateService, null);
        }
        return this._appStateService;
    }
    initAppState() {
        if (!this.appStateService)
            return;
        this.appStateService.setStateSlice(RISK_PROFILES_LIST_APP_STATE_SLICE_KEY);
        this.appStateService.setUrlParamKeys(RISK_PROFILES_LIST_STATE_KEYS);
        this.appStateService.start();
    }
    get enabled() {
        return this.appStateService?.enabled ?? false;
    }
}
RiskProfilesListAppStateService.ɵfac = function RiskProfilesListAppStateService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || RiskProfilesListAppStateService)(i0.ɵɵinject(i0.Injector)); };
RiskProfilesListAppStateService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: RiskProfilesListAppStateService, factory: RiskProfilesListAppStateService.ɵfac, providedIn: 'root' });
